import React from 'react'

export default function Label({text}) {
    return (
        <>
             <p className="inputLabel"> {text} </p>
        </>
    )
}
